import React from "react";
import { withRouter } from "react-router-dom";

import logo from "../../Assets/muy-coach-logo.svg";

function Terms() {
    return (
        <div className="w-full h-full bg-white">
            <div className="overflow-auto lg:pt-10 lg:pl-20 lg:pb-20">
                <img src={logo} alt="" className="h-[175px] w-[334px] max-[600px]:h-[80px] max-[600px]:w-[130px]" />
                <div className="bg-white">
                    <p className="sm:hidden md:hidden lg:flex font-black text-xl mt-10 mb-5  max-[600px]:hidden p-bold">
                        Terminos y Condiciones de Uso
                    </p>
                </div>
            </div>
        </div>
    );
}
export default withRouter(Terms);
